import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getActivityList } from "../../actions/Activity.action";
import { getRemarkList, getSavedList } from "../../actions/Saved.action";
import { IndividualSemisterResult } from "../../components/IndividualSemisterResult";
import RemarkSelector from "../../components/RemarkSelector/RemarkSelector";
import SemisterResultActivitySelector from "../../components/SemisterResultActivitySelector/SemisterResultActivitySelector";
import SemisterResultPrint from "../../components/SemisterResultPrint/SemisterResultPrint";
import Layout from "../../components/shared/Layout/Layout";

const SemisterResultPrintPage = ({
  data,
  activityData,
  getActivityList,
  getSavedList,
  getRemarkList,
}) => {
  const [activities, setActivities] = useState([]);
  const [remark, setRemark] = useState(null);
  useEffect(() => {
    const remFunc = async () => {
      if (data && data?.semister?.length > 0 && data?.student) {
        let res = await getRemarkList(
          data?.semister[0].id,
          data?.semister[0].term,
          data?.student?.id,
          data?.semister[0].year
        );
        console.log(res);
        if (res.remark) {
          setRemark(res.remark);
        }
      }
    };
    if (data && data?.semister?.length > 0 && data?.student) {
      getSavedList(data?.semister[0].id, data?.student?.id);

      remFunc();
    }
    if (!activityData) {
      getActivityList();
    }
  }, [data?.student?.id]);

  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Semister Result Print">
        <IndividualSemisterResult />
        {data ? (
          <>
            <SemisterResultPrint
              data={data}
              remark={remark}
              activities={activities}
            />
            <SemisterResultActivitySelector
              activities={activities}
              setActivities={setActivities}
              activityData={activityData}
              data={data}
            />
            {data?.semister.length > 0 ? (
              <RemarkSelector
                remark={remark}
                setRemark={setRemark}
                data={data?.semister[0]}
                studentId={data?.student?.id}
                year={data?.semister[0].year}
              />
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.mark.term,
  activityData: state.activity.activity,
});

export default connect(mapStateToProps, {
  getActivityList,
  getSavedList,
  getRemarkList,
})(SemisterResultPrintPage);
